import { PageNavState } from "./pageNav.types";

export const state: PageNavState = {
  pageNav: null
};
